import React from 'react';
import { useMediaQuery } from 'react-responsive';

import './style.css';

export const Pagination = ({ currentPage, numberOfRecords, totalRecords, onPageChange }) => {
  const totalPages = Math.ceil(totalRecords / numberOfRecords);

  const isMobile = useMediaQuery({ maxWidth: 520 });

  const handlePageChange = (pageNumber) => {
    onPageChange(pageNumber);

    if (isMobile) {
      window.scrollTo(0, 0);
    }
  };

  const renderPageButtons = () => {
    const buttons = [];
    const maxVisibleButtons = 4;

    if (totalPages <= maxVisibleButtons) {
      for (let i = 1; i <= totalPages; i++) {
        buttons.push(
          <button
            className="pagination-button"
            key={i}
            onClick={() => handlePageChange(i)}
            disabled={currentPage === i}
          >
            {i}
          </button>
        );
      }
    } else {
      let startPage = Math.max(currentPage - 2, 1);
      let endPage = startPage + maxVisibleButtons - 1;

      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = endPage - maxVisibleButtons + 1;
      }

      if (startPage > 1) {
        buttons.push(<span key="start-ellipsis">...</span>);
      }

      for (let i = startPage; i <= endPage; i++) {
        buttons.push(
          <button
            className="pagination-button"
            key={i}
            onClick={() => handlePageChange(i)}
            disabled={currentPage === i}
          >
            {i}
          </button>
        );
      }

      if (endPage < totalPages) {
        buttons.push(<span key="end-ellipsis">...</span>);
      }
    }

    return buttons;
  };

  return (
    <div className="pagination-block">
      <button
        className="pagination-button"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        &#8592;
      </button>
      {renderPageButtons()}
      <button
        className="pagination-button"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        &#8594;
      </button>
    </div>
  );
};
